export const fieldArrayOnDrag = fields => result => {
  if (!result.destination) return
  console.log(result)
  fields.insert(result.destination.index, fields.remove(result.source.index))

  //fields.swap(result.source.index, result.destination.index)
}
